// src/api/note.ts
import { BlogArticle } from '../types/blog';

const CREATOR_ID = 'kida_lw';
// noteの非公式APIはCORSヘッダを返さないため、同一オリジンのプロキシ経由でアクセスする。
//  - 開発: src/setupProxy.js が /note-api を note.com に転送
//  - 本番: REACT_APP_NOTE_API_BASE に本番プロキシ(例: Cloud Functions)のURLを設定
const NOTE_ORIGIN = process.env.REACT_APP_NOTE_API_BASE || '/note-api';
const API_BASE = `${NOTE_ORIGIN}/api/v2/creators/${CREATOR_ID}/contents`;
const NO_IMAGE_URL = '/images/Blog/NOIMAGE.svg';

// HTMLタグを除去してプレーンテキストの抜粋を作る
const toExcerpt = (html: string, maxLength = 120): string => {
  const text = (html ?? '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
};

// noteのコンテンツ1件をBlogArticle型に変換する
const toBlogArticle = (item: any): BlogArticle => {
  return {
    id: String(item.key ?? item.id),
    slug: String(item.key ?? item.id),
    title: item.name ?? '',
    excerpt: toExcerpt(item.body ?? ''),
    content: item.body ?? '',
    imageUrl: item.eyecatch || NO_IMAGE_URL,
    category: 'note',
    categoryIds: [],
    tags: Array.isArray(item.hashtag_notes)
      ? item.hashtag_notes.map((h: any) => h?.hashtag?.name).filter(Boolean)
      : [],
    author: item.user?.nickname ?? CREATOR_ID,
    publishedAt: item.publishAt ?? item.publish_at ?? '',
    // noteの記事はnote.com上に存在するため、外部URLを保持しておく
    externalUrl: item.noteUrl ?? `https://note.com/${CREATOR_ID}/n/${item.key}`,
  };
};

// isLastPageがtrueになるまでページをインクリメントしながら全記事を取得する
export const fetchNotePosts = async (): Promise<BlogArticle[]> => {
  const articles: BlogArticle[] = [];
  let page = 1;
  let isLastPage = false;

  try {
    while (!isLastPage) {
      const response = await fetch(`${API_BASE}?kind=note&page=${page}`, {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`note APIリクエストに失敗しました: ${response.status}`);
      }

      const json = await response.json();
      const data = json?.data ?? {};
      const contents: any[] = data.contents ?? [];

      articles.push(...contents.map(toBlogArticle));

      isLastPage = data.isLastPage === true || contents.length === 0;
      page += 1;
    }

    return articles;
  } catch (error: any) {
    console.error('note APIからのデータ取得エラー:', error);
    throw error;
  }
};
